import { createClient } from '@supabase/supabase-js';
import type { Database } from '../types/supabase';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('⚠️ Supabase credentials missing:', {
    url: supabaseUrl ? 'Present' : 'Missing',
    key: supabaseAnonKey ? 'Present' : 'Missing'
  });
  throw new Error('Supabase configuration is incomplete');
}

// Vérifier que les URLs sont valides
try {
  new URL(supabaseUrl);
} catch {
  console.error('⚠️ Invalid Supabase URL:', supabaseUrl);
  throw new Error('Invalid Supabase URL');
}

// Configuration simplifiée
const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: localStorage,
    flowType: 'pkce'
  },
  global: {
    headers: {
      'X-Client-Info': 'supabase-js-web'
    }
  }
});

// Test de connexion au démarrage
supabase.from('user_profiles').select('count').limit(1).then(
  ({ error }) => {
    if (error) {
      console.warn('⚠️ Supabase connection test failed:', error.message);
    } else {
      console.log('✅ Supabase connection successful');
    }
  },
  (e: unknown) => {
    const message = e instanceof Error ? e.message : String(e);
    console.warn('⚠️ Supabase connection test error:', message);
  },
);

export { supabase };